export const GET_STATIC_PAGE = 'GET_STATIC_PAGE';
export const RESPONSE_STATUS = 'RESPONSE_STATUS';
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE';
export const DECRYPT_USER_DETAILS = 'DECRYPT_USER_DETAILS';
